export type TerminalType = {
  contractId: string
  storeId: string
  terminalId: string
  terminalName: string
}
export const sameTerminalKey = (terminal: TerminalType): string => `${terminal.contractId}_${terminal.storeId}_${terminal.terminalId}`
